import React from 'react';
import ContestInfoBlockRenderer from './ContestInfoBlockRenderer';
import classes from './ContestInfo.module.css';

const ContestInfo = (props) => {

  const { blocks = [] } = props;
  
  return (
    <div className={classes.contestInfo}>
      {blocks.map((block) => (
        <ContestInfoBlockRenderer key={block.id} block={block} />
      ))}
    </div>
  );
};

export default ContestInfo;
